// extracted by mini-css-extract-plugin
export default {"wrap":"TabChat_wrap__tqyFD","chatContainer":"TabChat_chatContainer__+YF2g"};